// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Copy from '../_raw/ui/icon_copy.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Copy);
